import * as React from 'react';
// mui
import {
  Box,
  Typography,
  Slider,
  Button,
  Container,
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
// icons
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
// components
import { toDoSliderMarks } from '../../common/sliderMarks';
import ProjectExclusionSelect from '../ToDoForm/ProjectExclusionSelect';

interface ToDoFormProps {
  onPreferencesSubmitted: (time: number, energy: number, excludedProjectIds: number[]) => void;
}

export default function ToDoForm(props: ToDoFormProps) {
  // props
  const preferencesSubmittedCallback = props.onPreferencesSubmitted;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // local state
  const [ energyValue, setEnergyValue ] = React.useState(4);
  const [ timeValue, setTimeValue ] = React.useState(3);
  const [ excludedProjectIds, setExcludedProjectIds ] = React.useState<number[]>([])
  const [ loadingStatus, setLoadingStatus ] = React.useState(false);

  const findTaskTodo = () => {
    setLoadingStatus(true);

    preferencesSubmittedCallback(timeValue, energyValue, excludedProjectIds);
  }

  const handleExcludedProjectChange = (projectIds: number[]) => {
    setExcludedProjectIds(projectIds);
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      minHeight="calc(100vh - 112px)"
      width="100%"
      margin="0"
      padding="0"
    >
      <Container
        sx={{
          width: '100%',
          marging: 0,
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box width="calc(100% - 32px)">
          <Box my={4} mx={isMobile ? 1 : 10}>
            <Typography textAlign='center' variant="h6" gutterBottom>
              Find A Task To Do
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="subtitle1" gutterBottom>
              How much energy do you have right now?
            </Typography>
            <Slider
              value={energyValue}
              onChange={(e, val) => setEnergyValue(val)}
              step={1}
              min={1}
              max={5}
              marks={isMobile ? toDoSliderMarks.mobile.energy : toDoSliderMarks.desktop.energy}
              valueLabelDisplay="off"
            />
          </Box>

          <Box my={4} mx={isMobile ? 1.5 : 10}>
            <Typography variant="subtitle1" gutterBottom>
              How much time do you have?
            </Typography>
            <Slider
              value={timeValue}
              onChange={(e, val) => setTimeValue(val)}
              step={1}
              min={1}
              max={5}
              marks={toDoSliderMarks.desktop.time}
              valueLabelDisplay="off"
            />
          </Box>

          <ProjectExclusionSelect onChange={handleExcludedProjectChange} />

          <Box my={4} mx={10} display="flex" justifyContent="center" alignItems="center">
            <Button loading={loadingStatus} onClick={findTaskTodo} sx={{ width: 200 }} variant="contained">Find Task <KeyboardArrowRightIcon /></Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
